<template>
  <div>
    <div class="calendar">
      <div class="calendar-inner">
        <ul class="week">
          <li class="item">一</li>
          <li class="item">二</li>
          <li class="item">三</li>
          <li class="item">四</li>
          <li class="item">五</li>
          <li class="item">六</li>
          <li class="item">日</li>
        </ul>
        <ul class="dayList" v-for="(line,lineIndex) in showData">
          <li class="dayList-item" v-for="(showDay,dayIndex) in line" :class="{'active-col':day==showDay}" @click="dayClickFun(showDay)">
            {{showDay}}
            <p v-for="(key,keyIndex) in lessonData" :key="keyIndex" :class="[key == showDay? 'lesson_date' : '']" v-if="key == showDay">有课</p>
            <span :class="{active:today==showDay}"></span>
          </li>
        </ul>
      </div>
      <div class="header clearfix">
        <div class="header-center">
        <div @click="prevMonth" class="date-btn fl"><img src="../../../static/images/syy-images/left.png" width="100%"></div>
        <div class="year">{{year+"年"}}{{month+"月"}}</div>
        <div @click="nextMonth" class="date-btn fr"><img src="../../../static/images/syy-images/right.png" width="100%"></div>
        <p class="day">{{day}}<span>{{weekTxt}}</span></p>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "calendar",
    data () {
      return {
        //记录年月日
        year:"",
        month:"",
        day:"",
        //要展示和绑定的数据
        showData:[[],[],[],[],[]],
        weekTxt: '',
        prevDay:-1,//第1行占多少天
        weekDay:7,//星期天数
        allDay:42,//6行一共的天数
        monthDay:[],//保存当前年每月的天数
        today:"",//今天
        lessonData:[],//有课的日期
      }
    },
    created:function(){
      var date = new Date();
      this.year = date.getFullYear();
      this.month = date.getMonth()+1;
      this.today = date.getDate();
      this.day = date.getDate();
      this.monthDay = this.getMonthDay(this.year);
      this.week = this.getWeek(this.year);
      this.weekTxt = this.getWeekTxtFun(this.year,this.month,this.day);
      //初始化数据
      this.changeDay();
      this.$emit("getTimeTable", this.year+'-'+this.month+'-'+ this.day)
    },
    methods:{
      //判断是不是闰年
      isLearYear:function(year){
        var condition1 = year % 4 == 0;
        var condition2 = year % 100 !=0;
        var condition3 = year % 400 ==0;
        return condition1 && condition2 || condition3;
      },
      //获得当前年的每月的天数
      getMonthDay:function(year){
        var _arr=[31,31,30,31,30,31,31,30,31,30,31];
        if(this.isLearYear(year)){
          //闰年
          _arr.splice(1,0,29);
          return _arr;
        }else{
          //平年
          _arr.splice(1,0,28);
          return _arr;
        }
      },
      //当前年的一月一日是星期几
      getWeek:function(year){
        var _arr=["Mon","Tue","Wed","Thu","Fri","Sat","Sun"];
        var week = new Date(year+","+1+","+1).toString().split(" ")[0];
        return _arr.indexOf(week);
      },
      //星期几
      getWeekTxtFun:function(year,month,day){
        var _arr=["Mon","Tue","Wed","Thu","Fri","Sat","Sun"];
        var week = new Date(year+","+month+","+day).toString().split(" ")[0];
        switch(week){
          case 'Mon':
            this.weekTxt = '周一';
            break;
          case 'Tue':
            this.weekTxt = '周二';
            break;
          case 'Wed':
            this.weekTxt = '周三';
            break;
          case 'Thu':
            this.weekTxt = '周四';
            break;
          case 'Fri':
            this.weekTxt = '周五';
            break;
          case 'Sat':
            this.weekTxt = '周六';
            break;
          case 'Sun':
            this.weekTxt = '周日';
            break;
          default:
            break;
        }
        return this.weekTxt;
      },
      //修改天数数据
      changeDay:function(){
        var _arr=[[],[],[],[],[],[]];
        var index = Number(this.month-1);
        var day =1;
        //初始化
        if(index == 0 ){
          //1月
          this.prevDay == this.week;
          this.$set(this,"prevDay",this.week);
        }else{
          var allPrevDay=0;
          for(var i=0;i<index;i++){
            allPrevDay+=this.monthDay[i];
          }
          this.prevDay = (allPrevDay+this.week) % this.weekDay;
        }
        this.weekTxt = this.getWeekTxtFun(this.year,this.month,this.day);
        //第一行
        for(var i=0;i<7;i++){
          if(i<this.prevDay){
            _arr[0].push("");
          }else{
            _arr[0].push(day);
            day++;
          }
        }
        //第二到第四行
        for(var j=0;j<3;j++){
          for(var k=0;k<7;k++){
            _arr[j+1].push(day);
            day++;
          }
        }
        //第五行
        for(var q=0;q<7;q++){
          if(day > this.monthDay[index]){
            _arr[4].push("");
          }else{
            _arr[4].push(day);
            day++;
          }
        }
        //第六行
        for(var s=0;s<7;s++){
          if(day>this.monthDay[index]){
            _arr[5].push("");
          }else{
            _arr[5].push(day);
            day++
          }
        }
        //第五和第六可以合并成2层嵌套循环
        this.$set(this,"showData",_arr);
//        this.getDateLesson();
      },

      dayClickFun:function(day){
        if(day == ''){
          return
        }else{
          this.day = day;
          this.weekTxt = this.getWeekTxtFun(this.year,this.month,day)
          this.$emit("getTimeTable", this.year+'-'+this.month+'-'+ this.day)
        }
      },

      nextMonth:function(e){
        if(this.month == 12){
          this.$set(this,"month",1);
          this.$set(this,"year",this.year+1);
          this.$set(this,"monthDay",this.getMonthDay(this.year));
          this.week = this.getWeek(this.year);
        }else{
          this.$set(this,"month",this.month+1);
        }
        this.day=1;
        this.changeDay();
      },
      prevMonth:function(e){
        if(this.month == 1){
          this.$set(this,"month",12);
          this.$set(this,"year",this.year-1);
          this.$set(this,"monthDay",this.getMonthDay(this.year));
          this.week = this.getWeek(this.year);
        }else{
          this.$set(this,"month",this.month-1);
        }
        this.day=1;
        this.changeDay();
      },
      nextYear:function(e){
        this.$set(this,"year",this.year+1);
        this.$set(this,"monthDay",this.getMonthDay(this.year));
        this.week = this.getWeek(this.year);
        this.day=1;
        this.changeDay();
      },
      prevYear:function(e){
        this.$set(this,"year",this.year-1);
        this.$set(this,"monthDay",this.getMonthDay(this.year));
        this.week = this.getWeek(this.year);
        this.day=1;
        this.changeDay();
      },
    },
  }
</script>

<style scoped>
  .w{
    width: 1200px;
    margin: 0 auto ;
  }
  .fl{
    float: left;
  }
  .fr{
    float: right;
  }
  .calendar{
    position: relative;
    font-size: 0;
    display: flex;
    margin:0 auto 30px;
    width: 954px;
  }
  .header{
    border: 1px solid #e3e3e3;
    position: relative;
    width: 315px;
    text-align: center;
    display: inline-block;
    vertical-align: top;
    padding-top: 23px;
    box-sizing: border-box;
    flex-grow: 1;
  }
  .header-center{
    width: 242px;
    margin: 0 auto;
  }
  .year{
    display: inline-block;
    font-size: 20px;
    color: #343434;
    vertical-align: middle;
    width: 212px;
    height: 28px;
    line-height: 28px;
  }
  .month{
    display: inline-block;
  }
  .day{
    color: #1a71ff;
    font-size: 157px;
    text-align: center;
    font-weight: bold;
    margin-top: 55px;
    height: 156px;
    line-height: 156px;
  }
  .day span{
    font-size: 18px;
    color: #7e7e7e;
  }
  .calendar-inner{
    width: 679px;
    border: 1px solid #e3e3e3;
    border-right: none;
    display: inline-block;
  }
  .week{
    height: 43px;
    background: #f3f3f3;
    width: 679px;
    display: flex;
    margin-bottom: 23px;
  }
  .item{
    float: left;
    list-style: none;
    width: 48px;
    height: 43px;
    line-height: 43px;
    text-align: center;
    padding: 0;
    margin: 0;
    border-bottom: 1px solid #e3e3e3;
    flex: 1;
    color: #616161;
    font-size: 18px;
  }
  .dayList{
    width: 679px;
    display: flex;
  }
  .dayList-item{
    flex: 1;
    width: 48px;
    height:18px;
    margin-bottom: 30px;
    color: #7e7e7e;
    font-size: 18px;
    text-align: center;
    cursor: pointer;
  }
  .dayList-item.active-col{
    color: #1a71ff;
  }
  .active{
    background-color: #1a71ff;
    width: 8px;
    height: 8px;
    display: block;
    margin: 5px auto 0;
    border-radius: 50%;
  }
  .last,.prev{
    background-color: #1a71ff;
  }
  .date-btn{
    width: 15px;
    display:block;
    cursor: pointer;
  }
  .lesson_date{
    color: #1a71ff;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/components/calendar.vue